import React from 'react';
import { motion } from 'framer-motion';
export function WhyMeSection() {
  return <section id="why-me" className="pt-10 relative" data-id="element-159">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-160">
        <div className="mb-8" data-id="element-161">
          <h2 className="text-5xl md:text-6xl font-bold mb-3 tracking-tight" data-id="element-162">
            WHY ME
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-4 mb-12" data-id="element-163">
          {[{
          title: 'I KNOW HOW TO BUILD',
          desc: "I've built and scaled 3 successful businesses. In 2024, I built a consulting company to 6 figures within a year. This is my next move.",
          color: '#0088FF'
        }, {
          title: 'I HAVE THE NETWORK',
          desc: 'I want to make ethical creator monetization the default, not an afterthought. I already have a small team. Now I need mentors and investors to do it with.',
          color: '#8800FF'
        }, {
          title: "I'M ALL IN",
          desc: "$187k personal investment. This is my life's work. I know what burnout feels like and I know what a comeback requires.",
          color: '#00DD00'
        }].map((item, i) => <motion.div key={i} className="border-4 border-black p-5 bg-white relative" style={{
          borderTopWidth: '10px',
          borderTopColor: item.color
        }} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-164">
              <h3 className="text-lg font-bold mb-2" data-id="element-165">{item.title}</h3>
              <p className="text-sm leading-relaxed" data-id="element-166">{item.desc}</p>
            </motion.div>)}
        </div>

        {/* Companies I've Built - Levery Style */}
        <div className="py-12 border-t-4 border-b-4 border-black relative" data-id="element-167">
          <p className="text-xs font-bold tracking-widest text-gray-500 mb-6 text-center" data-id="element-168">
            COMPANIES I BUILT
          </p>
          <div className="flex flex-wrap justify-center items-center gap-12" data-id="element-169">
            <div className="h-12 w-32 flex items-center justify-center" data-id="element-170">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xjp2sD2AyP1xZ3k2Xx9n2y/keap-high-resolution-logo.png" alt="Keap" className="h-12 w-32 object-contain grayscale hover:grayscale-0 transition-all" data-id="element-171" />
            </div>
            <div className="h-12 w-32 flex items-center justify-center" data-id="element-172">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cq18bitmJfQATCmSUXqR7D/levery-high-resolution-logo-transparent.png" alt="Levery" className="h-12 w-32 object-contain grayscale hover:grayscale-0 transition-all" data-id="element-173" />
            </div>
            <div className="h-12 w-32 flex items-center justify-center" data-id="element-174">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eB68pF4EmijPPeePyYGJBu/pr-for-startups-high-resolution-logo.png" alt="PR for Startups" className="h-12 w-32 object-contain grayscale hover:grayscale-0 transition-all" data-id="element-175" />
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}